import { RootState } from '@reducers';

export const selectOtpToken = (state: RootState) => state.userRegistrationReducer.otpToken;
